import { Outlet, useLoaderData } from '@tanstack/react-router';
import { useEffect } from 'react';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import {
  TikTokCampaignTabs,
  TikTokCampaignNotice,
  TikTokCampaignHeader,
  useTikTokCampaignRoutes
} from '@anytag/shared-organisms';
import { TikTokRouter } from '../../../app/_private-routes/tiktok';
import { TikTokCampaignDetailsProvider } from './TikTokCampaignDetailsContext';

export const TikTokCampaignDetails = () => {
  const { getTikTokCampaignsListRoute } = useTikTokCampaignRoutes();
  const { t, enqueueSnackbar, navigate } = useQueryHelper();
  const { loading, networkStatus, errorMessage, tiktokSpecialCampaign } = useLoaderData({
    from: '/_private-routes/tiktok/campaigns/$id'
  }) as Awaited<ReturnType<(typeof TikTokRouter)['/_private-routes/tiktok/campaigns/$id']['1']['loader']>>;

  useEffect(() => {
    if (errorMessage) {
      enqueueSnackbar(t(errorMessage), { variant: 'error' });
      navigate({ to: getTikTokCampaignsListRoute() });
    }
  }, [errorMessage]);

  return (
    <RenderDataWithFallback loading={loading && networkStatus === 1}>
      {tiktokSpecialCampaign && (
        <TikTokCampaignDetailsProvider value={{ tiktokSpecialCampaign }}>
          <TikTokCampaignHeader tiktokSpecialCampaign={tiktokSpecialCampaign} />
          <TikTokCampaignNotice css={{ marginBottom: '8px' }} tiktokSpecialCampaign={tiktokSpecialCampaign} />
          <TikTokCampaignTabs tiktokSpecialCampaign={tiktokSpecialCampaign} />
          <Outlet />
        </TikTokCampaignDetailsProvider>
      )}
    </RenderDataWithFallback>
  );
};
